import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Helmet } from 'react-helmet-async';
import SvgUpArrowIcon from '../../svg/UpArrowIcon'; 
import { loadAuditLogsReport } from '../../../redux/actions/reportsActions';
import LoadingSpinner from '../../shared/LoadingSpinner';
import { connect } from 'react-redux';
import { ReportsTable } from '../../shared/table/Reportstable';
import '../../../scss/partials/shared/tables/reportsTableStyles.css';

export function UnconnectedAuditLogReports(props) {
  const { auditLogs, apiSpinner } = props;

 useEffect(()=>{
    props.dispatch(loadAuditLogsReport());
      
 },[]); // eslint-disable-line

  const logTimeText = (
    <FormattedMessage
      id="auditLogReports.logTimeText"
      defaultMessage="Log Time"
      description="LogTime column Display text for auditlog table"
    />
  );

  const loggedByText = (
    <FormattedMessage
      id="auditLogReports.loggedByText"
      defaultMessage="Logged By"
      description="LoggedBy column Display text for auditlog table"
    />
  );

  const logMessageText = (
    <FormattedMessage
      id="auditLogReports.logMessageText"
      defaultMessage="Log Message"
      description="LogMessage column Display text for auditlog table"
    />
  );
  const csvHeaders = ['Log Time', 'Logged By', 'Log Message'];
  let csvData = [];

  //Ascending/Descending sorting functionality 
  const [sortColumn, setSortColumn] = useState('LogTime');
  const [isDescending, setIsDescending] = useState(true);

  const handleSort = (column) => {
    if (sortColumn === column) {
      setIsDescending(!isDescending); 
    } else {
      setSortColumn(column);
      setIsDescending(false); 
    }
  };
  
  const auditLogTable = () => {
    const daysOfWeek = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
    const months = ['01','02','03','04','05','06','07','08','09','10','11','12'];
    const logs = [];
    auditLogs.map((log) => {
      let dateTimeStr = log.log_time;
      let dateObj = new Date(dateTimeStr);
      let day = daysOfWeek[dateObj.getDay()];
      let month = months[dateObj.getMonth()];
      let date = dateObj.getDate() < 10 ? '0'+ dateObj.getDate() : dateObj.getDate();
      let year = dateObj.getFullYear();
      let time = dateObj.toTimeString().slice(0,8);
      let DateTime = `${month}/${date}/${year} ${day} ${time}`;
      logs.push({
        LogTime: {
          sortBy: DateTime.toUpperCase(),
          display: DateTime,
          originalTimestamp: dateObj.getTime()
        },
        LoggedBy: {
          sortBy: log.log_by.toUpperCase(),
          display: log.log_by
        },
        LogMessage: {
          sortBy: log.log.toUpperCase(),
          display: log.log
        }
      });
      csvData.push([DateTime,log.log_by,log.log]);
      return '';
    });
    

      if(logs.length >0){
      const tableHeadings = [
        {
          isSortable: true,
          sortBy: 'LogTime',
          display: logTimeText,
          onClick: () => handleSort('LogTime'),
        },
        {
          isSortable: true,
          sortBy: 'LoggedBy',
          display: loggedByText,
          onClick: () => handleSort('LoggedBy'),
        },
        {
          isSortable: true,
          sortBy: 'LogMessage',
          display: logMessageText,
          onClick: () => handleSort('LogMessage'),
        },
      ];

      // generates the actual table
      const table = (
        <ReportsTable
          tableHeadings={tableHeadings}
          sortParam={sortColumn}
          tableData={logs}
          isDescending={isDescending}
          initialValue={10}
          csvHeaders={csvHeaders}
          csvData={csvData}
          csvTitle="Audit_Log_Reports"
          tableStyles="text-small tableflex"
          dataTest="audit-logs-table"
          onHeaderClick={handleSort}
        />
      );
      return table;
    } else {
      return (
        <span className="text-dimmed margin-right-10" data-test="no-logs-message">
          <FormattedMessage
            id="auditLogReports.noLogs"
            defaultMessage="No Audit Logs Found"
            description="Message indicating no audit Logs to display"
          />
        </span>
      );
    }
  };

  function tableDisplay() {
    if (auditLogs.length > 0 || apiSpinner.auditLogsReportReturned) {
      return auditLogTable();
    } else {
      return (
        <div className="loading-spinner__user-list-container">
          <LoadingSpinner />
        </div>
      );
    }
  }



 const backText = (
  <FormattedMessage
    id="auditLogReports.backText"
    defaultMessage="Back to Reports"
    description="Link back to the users interface"
  />
  );

  const auditLogReportsText = (
    <FormattedMessage
      id="auditLogReports.auditLogReportsText"
      defaultMessage="Audit Log Reports"
      description="Heading Text for the Audit Log Reports Page"
    />
  );

  

  return (
    <div className="container">
      <FormattedMessage
        id="auditLogReports.browserTabInfo"
        defaultMessage="Reports | Audit Log"
        description="Done button">
        {(txt) => (
          <Helmet>
            <title>{txt}</title>
          </Helmet>
        )}
      </FormattedMessage>
      <div
        className="layout-container--wide content-container content-container--column content-container--shadow"
        data-test="display-container">
        <div className="header-container_2-column">
        <div className="placeend margin-bottom-10">
          <h1 className="no-margin text-center" data-test="display-title">
            {auditLogReportsText}
          </h1>
        </div>
        <div className="placeend vertical-align-center margin-bottom-10">
          <a
            className="link-text align-center"
            href="/reports/reportscr.php"
            data-test="navigate-back-link">
            <SvgUpArrowIcon className="rotate-90-ccw margin-right-10" />
            {backText}
          </a>
        </div>
        </div>
      {tableDisplay()}
      <div className="width-100 align-center flex-around margin-bottom-10">
          <a
            className="link-text align-center"
            href="/reports/reportscr.php"
            data-test="navigate-back-link">
            <SvgUpArrowIcon className="rotate-90-ccw margin-right-10" />
            {backText}
          </a>
        </div>
      </div>
    </div>
    
  );
}

const mapStateToProps = (state) => {
  return {
    auditLogs: state.reports.logs.auditLogs,
    apiSpinner: state.ui.apiSpinner,
  };
};


export default connect(mapStateToProps)(UnconnectedAuditLogReports);
